import { Tag, Tooltip } from "antd";

export default function AlertStatusTag({ status }: { status?: string }) {
  if (!status) {
    return (
      <Tooltip title='There is no "alert me if..." criteria defined for this alert, and it is not associated with any insights.'>
        <Tag
          color="#00000040"
          className="justify-self-start w-fit"
          variant="solid"
        >
          No alert set
        </Tag>
      </Tooltip>
    );
  }
  const statusConfig = {
    alerted: {
      color: "#991962",
      label: "ALERTED",
      textColor: "white",
      title:
        'Your alert is triggered, and has met the "Alert me if..." criteria you defined.',
    },
    monitored: {
      color: "#D2EFF9",
      label: "MONITORED",
      textColor: "#06709B",
      title:
        'Your alert is being monitored, but has not met the "Alert me if..." criteria you defined since the insight was last updated.',
    },
    archived: {
      color: "#00000040",
      label: "ARCHIVED",
      textColor: "#FFF",
      title: "This alert is archived and does not update.",
    },
    unset: {
      color: "#00000040",
      label: "UNSET",
      textColor: "#FFF",
      title: `There is no "alert me if..." criteria defined for this alert, and it is not associated with any insights.`,
    },
  };

  const config = statusConfig[status as keyof typeof statusConfig];

  if (!config) {
    return (
      <Tag
        color="#00000040"
        className="justify-self-start w-fit"
        variant="solid"
      >
        Unknown status
      </Tag>
    );
  }

  return (
    <Tooltip title={config.title}>
      <Tag
        color={config.color}
        variant="solid"
        aria-label={`Alert status: ${config.label}`}
        className="justify-self-start w-fit"
      >
        <span style={{ color: config.textColor, fontSize: "14px" }}>
          {config.label}
        </span>
      </Tag>
    </Tooltip>
  );
}
